import { useState } from 'react';
import useSWRMutation from 'swr/mutation';
import { NudosButton, NudosGenericModal, NudosModalContent } from 'components/NudosComponents';
import { IFloatSelectSerialItem } from '../../FloatSelectSerial';
import { formatShortDate } from 'utils/formatDatesAndHours';
import { cancelReservationStock } from 'services/stockOrders';
import { IDeleteReservationStockItem } from 'types/stockOrders';
import { displaySuccessNotification } from 'utils/displayNudosStandardNotifications';
import { SWR_KEYS } from 'constants/constants';
import useStockReservationState from 'state/useStockReservationState';
import './CancelReservationModal.scss';
import CancelReservationModalContent from './Components/CancelReservationModalContent/CancelReservationModalContent';

interface ICancelReservationModal {
  isOpen: boolean;
  onClose: () => void;
  items: IFloatSelectSerialItem[];
  orderId: string;
  stockProductsIds: IDeleteReservationStockItem;
  onSuccess: () => void;
}

const CancelReservationModal = ({
  isOpen,
  onClose,
  items,
  orderId,
  stockProductsIds,
  onSuccess
}: ICancelReservationModal) => {
  const [shouldCloseModal, setShouldCloseModal] = useState(false);
  const { setRefreshStockProductAvailabilityData } = useStockReservationState();

  const { trigger: cancelReservationStockTrigger, isMutating: isLoadingCancelReservation } = useSWRMutation(
    SWR_KEYS.cancelReservationStock,
    async (
      __,
      {
        arg
      }: {
        arg: IDeleteReservationStockItem;
      }
    ) => {
      return await cancelReservationStock(arg);
    },
    {
      onSuccess: () => {
        setShouldCloseModal(false);
        displaySuccessNotification({
          customJSXMessage: <>Reserva de stock cancelada correctamente</>,
          duration: 3000
        });
        onClose();
        onSuccess();
        setRefreshStockProductAvailabilityData(true);
      }
    }
  );

  const handleCancelReservation = () => {
    cancelReservationStockTrigger(stockProductsIds);
  };

  if (!isOpen) return null;

  return (
    <NudosGenericModal
      customClassName="relative"
      shouldCloseModal={shouldCloseModal}
      closesOnClickOutside={false}
      closeModalCallback={onClose}
      modalContent={
        <NudosModalContent
          modalContentTitle="Cancelar reserva de todos las unidades"
          toCloseModal={() => setShouldCloseModal(true)}
          CustomModalComponent={
            <CancelReservationModalContent
              items={items}
              handleCancelReservation={handleCancelReservation}
              setShouldCloseModal={setShouldCloseModal}
              isLoadingCancelReservation={isLoadingCancelReservation}
              orderId={orderId}
            />
          }
          customWidth="580px"
          customHeight="426px"
        />
      }
    />
  );
};

export default CancelReservationModal;
